<template>
    <div class="sb-border">
        <div class="logo-wrapper">
            <img
                class="sb-logo"
                src="../../assets/images/branded/sb-final/SB-Logo_1_D@2x.webp"
                alt="Spelling Bee Logo"
            >
            <template v-if="isMobile">
                <div class="sb-vertical-divider" />
                <img
                    class="sb-pop-logo"
                    src="../../assets/images/branded/sb-final/SB-POP_Yourself_Logo@2x.webp"
                    alt="Spelling Bee Logo"
                >
            </template>
        </div>
        <div class="sb-background" />
    </div>
</template>

<script>
    export default {
        computed: {
            isMobile() {
                return this.$store.state.customizer.isMobile;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../style/variables.scss";

    #cz2.cz2__is-sb {
        .logo-wrapper {
            margin-top: 24px;
            padding-top: 8px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
        }

        .sb-vertical-divider {
            z-index: 1;
            height: 60px;
            width: 2px;
            background-color: color(sbDarkGold);
            margin-right: 8px;
            margin-left: 8px;
            flex: 0 0 auto;
        }

        .sb-logo {
            z-index: 1;
            width: 200px;
            @include respond-above(lg) {
                width: 462px;
            }
        }

        .sb-pop-logo {
            width: 60px;
            z-index: 1;
        }

        .sb-background {
            position: absolute;
            top: 32px;
            left: 32px;
            background-image: url('../../assets/images/branded/sb-final/SB-Background_pattern_3_M@2x.jpg');
            @include respond-above(lg) {
                background-image: url('../../assets/images/branded/sb-final/SB-Background_pattern_4_D@2x.jpg');
                background-repeat: repeat;
            }
            background-size: cover;
            height: calc(100vh - 64px);
            width: calc(100vw - 64px);
        }
    }

    #cz2.cz2__is-sb.cz2__is-kiosk {
        .sb-background {
            background-image: url('../../assets/images/branded/sb-final/SB-Background-pattern-2_K@2x.jpg');
        }
    }
</style>
